import { apiClient } from './apiClient';

export interface WebsiteIntegration {
  connected_domains: string[];
  lead_capture_active: boolean;
  chatbot_active: boolean;
  notifications: {
    recipients: string[];
    notify_new_leads: boolean;
    notify_chatbot_leads: boolean;
    notify_follow_ups_due: boolean;
  };
  business_email: string;
  contact_phone: string;
  publishable_key_id: string | null;
  embed_snippet: string | null;
}

export interface IssuedKey {
  publishable_key_id: string;
  publishable_key: string; // shown once
  allowed_origins: string[];
  embed_snippet: string;
}

class WebsiteIntegrationService {
  async get(): Promise<WebsiteIntegration> {
    return apiClient.get('/settings/website-integration/');
  }

  async update(patch: Partial<{
    notify_new_leads: boolean;
    notify_chatbot_leads: boolean;
    notify_follow_ups_due: boolean;
    business_email: string;
    allowed_origins: string[];
  }>): Promise<WebsiteIntegration> {
    return apiClient.patch('/settings/website-integration/', patch);
  }

  /** Create/rotate the publishable key. The raw key + full snippet are returned ONCE. */
  async issueKey(allowedOrigins: string[]): Promise<IssuedKey> {
    return apiClient.post('/settings/website-integration/publishable-key/', {
      allowed_origins: allowedOrigins,
    });
  }

  async testConnection(): Promise<{ ok: boolean; message: string }> {
    return apiClient.post('/settings/website-integration/test-connection/', {});
  }
}

export const websiteIntegrationService = new WebsiteIntegrationService();
